import BaseAPI from './base';

class OrdersAPI extends BaseAPI {
  create(slug: string, order: Record<string, unknown>) {
    return this.post(`/api/web/v1/demarches/${slug}/orders`, { order });
  }

  show(slug: string, token: string) {
    return this.get(`/api/web/v1/demarches/${slug}/orders/${token}`, {});
  }

  update(slug: string, token: string, order: Record<string, unknown>) {
    return this.patch(`/api/web/v1/demarches/${slug}/orders/${token}`, { order });
  }

  submit(slug: string, token: string, payload: Record<string, unknown>) {
    return this.post(`/api/web/v1/demarches/${slug}/orders/${token}/submit`, payload);
  }

  // Hands back Stripe's hosted Checkout URL; takes no body (backend-plan.md §7.2).
  pay(slug: string, token: string) {
    return this.post(`/api/web/v1/demarches/${slug}/orders/${token}/payment`, {});
  }
}

export default new OrdersAPI();
